import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache: { name: string; logo_screen: string | null; address?: string; phone?: string; email?: string } | null = null;

export function useBranding() {
  const [b, setB] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/public/branding").then((r) => {
      cache = r.data;
      setB(r.data);
    });
  }, []);
  return b;
}

export const refreshBranding = () => {
  cache = null;
};

type Variant = "premium" | "flat-white" | "flat-black";

export function Logo({ variant = "flat-white", className = "", custom = true }: { variant?: Variant; className?: string; custom?: boolean }) {
  const b = useBranding();
  if (custom && b?.logo_screen) return <img src={b.logo_screen} alt="NMS Nabil Chettab" className={className} data-testid="brand-logo" draggable={false} />;
  if (variant === "flat-white") {
    return (
      <>
        <img src="/brand/nms-flat-white.svg" alt="NMS Nabil Chettab" className={`${className} [.light_&]:hidden`} data-testid="brand-logo" draggable={false} />
        <img src="/brand/nms-flat-black.svg" alt="NMS Nabil Chettab" className={`${className} hidden [.light_&]:block`} draggable={false} />
      </>
    );
  }
  return <img src={`/brand/nms-${variant}.svg`} alt="NMS Nabil Chettab" className={className} data-testid="brand-logo" draggable={false} />;
}

export function Monogram({ className = "" }: { className?: string }) {
  return (
    <>
      <img src="/brand/nms-monogram.svg" alt="NMS" className={`${className} [.light_&]:hidden`} data-testid="brand-monogram" draggable={false} />
      <img src="/brand/nms-monogram-black.svg" alt="NMS" className={`${className} hidden [.light_&]:block`} draggable={false} />
    </>
  );
}
